module.exports = __webpack_public_path__ + "img/introductionBgImg3.675caeae.png";